import { useState } from 'react';
import { ErrorMessage, Form, Formik } from 'formik';
import { Button, Segment, SemanticSIZES } from 'semantic-ui-react';
import { AgreeFormValues, PermitFormValues } from '../../../../app/models/permit';
import { observer } from 'mobx-react-lite';
import PermitFormStep0Carpool from './PermitFormStep0Carpool';
import PermitFormStep0Vanpool from './PermitFormStep0Vanpool';
import { getPermitType } from '../../../../app/common/util/util';
import { Step0FormValidationSchema } from '../../../../app/common/form/FormikFormValidations';
import MyCheckInput from '../../../../app/common/form/MyCheckInput';
import ValidationErrors from '../../../errors/ValidationErrors';
import { router } from '../../../../app/router/Routes';

interface Props {
    values: PermitFormValues,
    next: () => void,
    buttonSize: SemanticSIZES
}

export default observer(function PermitFormStep0({ 
    values,
    next,
    buttonSize
 }: Props) {
    const [agrees, setAgrees] = useState(new AgreeFormValues());

    return (
        <Formik
            initialValues={agrees}
            onSubmit={() => next()}
            validationSchema={Step0FormValidationSchema}
        >
        {({handleSubmit, isSubmitting, errors, dirty, isValid}) => (
            <Form className='ui form error' onSubmit={handleSubmit} autoComplete='off'>
                <Segment attached clearing>
                    {values.permitTypeId === 2 && 
                        <PermitFormStep0Carpool />
                    }
                    {values.permitTypeId === 3 && 
                        <PermitFormStep0Vanpool />
                    }

                    <Segment raised>
                        <MyCheckInput name='agreed1' 
                            label={<label>I certify that all members of my {getPermitType(values.permitTypeId, true)} understand and accept the above Terms and Conditions.</label>} 
                            onChange={(checked: boolean) => setAgrees({...agrees, agreed1 : checked})}
                        />
                    </Segment>
                    <Segment raised>
                        <MyCheckInput name='agreed2' 
                            label={<label>I understand and accept the above Terms and Conditions.</label>} 
                            onChange={(checked: boolean) => setAgrees({...agrees, agreed2 : checked})}
                        />
                    </Segment>

                    <ErrorMessage 
                        name='error' render={() => 
                        <ValidationErrors errors={errors.error}/>}
                    />
                    <Button
                        loading={isSubmitting} 
                        onClick={() => router.navigate(`${process.env.PUBLIC_URL}/permits`)}
                        content={`I DON'T AGREE`}
                        size={buttonSize}
                    />
                    <Button
                        disabled={!dirty || !isValid}
                        loading={isSubmitting} 
                        floated='right'
                        positive
                        type='submit'
                        content='I AGREE'
                        size={buttonSize}
                    />
                </Segment>
            </Form>
            )}
        </Formik>
    )
})